<template>
  <div class="pa-6">
    <v-container fluid>
      <v-row>
        <v-col>
          <h2 class="primary--text">{{ $t(pageTitle) }}</h2>
        </v-col>
        <v-col>
          <!-- 登録ボタン -->
          <slot name="button" />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="textStyle">
          <!-- 検索 -->
          <slot name="search" />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="textStyle">
          <!-- 一覧 -->
          <slot name="list" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  components: {
    //
  },
  props: {
    pageTitle: {
      type: String,
      require: true,
      default: ''
    }
  },
  data: () => ({
    //
  })
}
</script>
<style scoped lang="scss">
.textStyle {
  font-size: 12px;
}
</style>
